
const TicketResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"provider": 0,
		"providerName": "string",
		"bookedBy": "string",
		"orderBy": "string",
		"clientBalance": 0,
		"paymentDeadline": "2023-04-15T11:41:48.402Z",
		"vatNumber": "string",
		"supplierName": "string",
		"totalNetRate": 0,
		"currency": "string",
		"checkIn": "2023-04-15T11:41:48.402Z",
		"checkOut": "2023-04-15T11:41:48.402Z",
		"rooms": [
			{
				"name": "string",
				"mealType": "string",
				"sharingBedding": true,
				"badGroups": "string",
				"passengers": [
					{
						"firstName": "string",
						"lastName": "string",
						"passengerType": 1,
						"passengerGender": 1,
						"childAge": 0,
						"nationalID": "string",
						"passportNumber": "string"
					}
				]
			}
		],
		"amenities": [
			"string"
		],
		"hotelConfirmationNo": "string",
		"remarks": [
			"string"
		],
		"gdsRefrenceID": "string"
};
 

  export default TicketResponse;
  